<template>
  <main-content>
    <template v-slot:left>
      <i class="fas fa-hard-hat mr-3"></i>
      {{pageTitle}}
    </template>
    <template v-slot:right></template>
    <div class="col-12 col-lg-11">
      <div class="card-body text-center">
      </div>

      <Datatable
        ref="datatable"
        :tableTitle="pageTitle"
        :fetchData="getData"
        :columns="columns"
        :tableClasses="['table-bordered', 'table-hover', 'text-nowrap']"
      >
        <template v-slot:table-body="data">
          <tr v-if="Object.keys(data).length==0" class="odd">
            <td
              valign="top"
              colspan="9"
              class="text-center dataTables_empty"
            >No playlist created yet</td>
          </tr>

          <tr v-for="playlist in data" :key="playlist.id">
            <td>
              {{playlist.name}}
              <br />
              <strong>Scheduling</strong>
              {{playlist.type}}
              <br />
              <strong># of Tracks:</strong>
              {{playlist.tracks_count}}
              ( {{playlist.created_at | moment_fromNow}} )
            </td>
            <td>
              <a
                class="btn btn-info btn-sm mr-2"
                href="#"
                @click.prevent="doEdit(playlist)"
              >Edit</a>
              <a
                class="btn btn-danger btn-sm"
                href="#"
                @click.prevent="doDelete(playlist)"
              >Delete</a>
            </td>
          </tr>
        </template>

        <template v-slot:header>
          <button
            :disabled="!onLine"
            type="button"
            class="btn btn-success mr-2 btn-sm float-right"
            @click.prevent="doCreate"
          >Add playlist</button>
        </template>
      </Datatable>
      <edit-modal
        ref="editModal"
        :create-url="this.url"
        :station-time-zone="'UTC'"
        @relist="relist"
      ></edit-modal>
    </div>
  </main-content>
</template>

<script>
import Datatable from "@/components/datatable/Datatable.vue";
import EditModal from "./Playlists/EditModal.vue";
import { FETCH_PLAYLISTS } from "@/store/action-types";
import ApiService from "@/plugins/ApiService";

export default {
  components: {
    Datatable,
    EditModal,
  },

  methods: {
    doCreate() {
      this.$refs.editModal.create();
    },
    doEdit(playlist) {
      this.$refs.editModal.edit(playlist);
    },

     async doDelete(playlist) {

        swal.fire({
        text: `Are you sure you want to delete ${playlist.name} playlist.`,
        confirmButtonText: "Delete",
        confirmButtonColor: "#e64942",
        showCancelButton: true,
        focusCancel: true,
      }).then(async (result)  =>  {
        if (result.value) {

      this.loading = true;
      await ApiService.send("admin/playlists/" + playlist.id, "delete");
      this.loading = false;
      this.relist();

      }
      });

      
    },

    relist() {
      if (this.$refs.datatable) {
        this.$refs.datatable.getData();
      }
    },

    getData(data) {
      return this.$store.dispatch(FETCH_PLAYLISTS, data);
    },
  },

  data() {
    return {
      pageTitle: "Playlists",
      url: "admin/playlists",
      playlists: [],
      selectedItems: [],
      columns: [{ label: "Playlist" }, { label: "Action" }],
    };
  },
};
</script>

